import { useCallback, useEffect, useLayoutEffect } from 'react';
import {
  CommentActionType,
  CommentAnchorCheckEvent,
  CommentAnchorKey,
} from '../directUser/index';
import useCurrentModuleProp from './useCurrentModuleProp';

function useAutoOpenCommentCenter(setPanelVisible) {
  const CurrentModuleProp = useCurrentModuleProp();

  const openCommentCenter = useCallback(() => {
    const anchorRecord = JSON.parse(
      sessionStorage.getItem(CommentAnchorKey) || '{}',
    );
    if (anchorRecord.actionType === CommentActionType.OpenCommentCenter) {
      setPanelVisible(true);
    }
  }, []);

  // open comment center when module name change
  useEffect(() => {
    openCommentCenter();
  }, [CurrentModuleProp.moduleName]);

  // open comment center when received an event
  useLayoutEffect(() => {
    window.addEventListener(CommentAnchorCheckEvent, openCommentCenter);

    return () => {
      window.removeEventListener(CommentAnchorCheckEvent, openCommentCenter);
    };
  }, []);
}

export default useAutoOpenCommentCenter;
